<form [formGroup]="form">
    <table class="w-100">
        @for (telemetry of controls; track telemetry) {
            <tr>
                <td>
                    <div>
                        @switch (telemetry.controlType) {
                            @case (controlTypes.Toggle) {
                                <div>
                                    <app-standard-toggle-switch
                                        [label]="telemetry.caption"
                                        [toggledLabel]="'defaults.true' | translation | async"
                                        [toggledTooltip]="'telemetry.propertyIsEnabled' | translation | async"
                                        [notToggledLabel]="'defaults.false' | translation | async"
                                        [notToggledTooltip]="'telemetry.propertyIsEnabled' | translation | async"
                                        [formControlName]="telemetry.name"
                                    ></app-standard-toggle-switch>
                                </div>
                            }
                            @case (controlTypes.TextBox) {
                                <div>
                                    <app-standard-textbox [addOnText]="telemetry.unit" [label]="telemetry.caption" [formControlName]="telemetry.name"></app-standard-textbox>
                                </div>
                            }
                        }
                    </div>
                </td>
            </tr>
        }
    </table>
</form>
